/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrescriptionOrderDetailDto
 */
export interface PrescriptionOrderDetailDto {
    /**
     * Internal prescription order ID (UUID)
     * @type {string}
     * @memberof PrescriptionOrderDetailDto
     */
    id: string;
    /**
     * Prescription ID this order belongs to
     * @type {string}
     * @memberof PrescriptionOrderDetailDto
     */
    prescriptionId: string;
    /**
     * External order ID from 3rd party service
     * @type {string}
     * @memberof PrescriptionOrderDetailDto
     */
    externalOrderId: string;
    /**
     * External resource provider
     * @type {string}
     * @memberof PrescriptionOrderDetailDto
     */
    externalResource: PrescriptionOrderDetailDtoExternalResourceEnum;
    /**
     * Order creation timestamp
     * @type {Date}
     * @memberof PrescriptionOrderDetailDto
     */
    createdAt: Date;
    /**
     * Order last update timestamp
     * @type {Date}
     * @memberof PrescriptionOrderDetailDto
     */
    updatedAt: Date;
    /**
     * Raw order data from 3rd party Supplement Provider API (untransformed)
     * @type {object}
     * @memberof PrescriptionOrderDetailDto
     */
    orderData: object;
}


/**
 * @export
 */
export const PrescriptionOrderDetailDtoExternalResourceEnum = {
    PersonalizedNutrients: 'personalized_nutrients',
    CelleraMedicine: 'cellera_medicine',
    RxntEhr: 'rxnt_ehr'
} as const;
export type PrescriptionOrderDetailDtoExternalResourceEnum = typeof PrescriptionOrderDetailDtoExternalResourceEnum[keyof typeof PrescriptionOrderDetailDtoExternalResourceEnum];


/**
 * Check if a given object implements the PrescriptionOrderDetailDto interface.
 */
export function instanceOfPrescriptionOrderDetailDto(value: object): value is PrescriptionOrderDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('prescriptionId' in value) || value['prescriptionId'] === undefined) return false;
    if (!('externalOrderId' in value) || value['externalOrderId'] === undefined) return false;
    if (!('externalResource' in value) || value['externalResource'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('orderData' in value) || value['orderData'] === undefined) return false;
    return true;
}

export function PrescriptionOrderDetailDtoFromJSON(json: any): PrescriptionOrderDetailDto {
    return PrescriptionOrderDetailDtoFromJSONTyped(json, false);
}

export function PrescriptionOrderDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrescriptionOrderDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'prescriptionId': json['prescriptionId'],
        'externalOrderId': json['externalOrderId'],
        'externalResource': json['externalResource'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'orderData': json['orderData'],
    };
}

export function PrescriptionOrderDetailDtoToJSON(json: any): PrescriptionOrderDetailDto {
    return PrescriptionOrderDetailDtoToJSONTyped(json, false);
}

export function PrescriptionOrderDetailDtoToJSONTyped(value?: PrescriptionOrderDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'prescriptionId': value['prescriptionId'],
        'externalOrderId': value['externalOrderId'],
        'externalResource': value['externalResource'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'orderData': value['orderData'],
    };
}

